import { Provider } from '@angular/core'

import {
  AppContext,
  Utils,
  ObjectHelper,
  HttpHelper,
  TypeOf,
  DependencyContainer
} from '../../../helpers'

import { BaseModel } from '../../../data/models'

import {
  EntityMappingFactory,
  IOperationServiceConfig,
  OperationServiceBuilder,
  ModelIdentityMap,
} from '../../../model-repository'

import { UriFactory } from '../../../core/factories'
import { ProviderHelper } from '../provider-helper'
import { OperationServiceAdapter } from '../../../data/services'

export class OperationServiceProvider {
  private _dependencyContainer: DependencyContainer
  private _providerHelper: ProviderHelper<OperationServiceProvider>

  constructor(
    private _apiRoot: string,
    private _operationServiceConfigs: Array<IOperationServiceConfig<any>>,
    private _identityMap?: ModelIdentityMap
  ) {
    this._providerHelper = new ProviderHelper(OperationServiceProvider, this)
    this._dependencyContainer = new DependencyContainer()
  }

  public createAngularProviders() {
    const builderDependencies = [HttpHelper, AppContext, Utils, UriFactory, ObjectHelper]
    const providers: Provider[] = [
      {
        provide: OperationServiceBuilder,
        deps: builderDependencies,
        useFactory: this._providerHelper.withEnsuredDIDependencies(
          builderDependencies, (
            httpHelper,
            appContext,
            utils,
            uriFactory,
            objectHelper
          ) => {
            return this._operationServiceBuilderFactory(
              httpHelper,
              appContext,
              utils,
              uriFactory,
              objectHelper
            )
          }
        )
      }
    ]
    this._operationServiceConfigs.forEach((operationServiceConfig) => {
      providers.push(
        {
          provide: operationServiceConfig.service,
          deps: [OperationServiceBuilder],
          useFactory: this._operationServiceFactoryFactory(operationServiceConfig.service)
        }
      )
    })
    return providers
  }

  private _operationServiceBuilderFactory(
    httpHelper: HttpHelper,
    appContext: AppContext,
    utils: Utils,
    uriFactory: UriFactory,
    objectHelper: ObjectHelper
  ): OperationServiceBuilder {
    const builder = new OperationServiceBuilder(
      this._apiRoot,
      httpHelper,
      utils,
      appContext,
      new EntityMappingFactory(utils, objectHelper),
      uriFactory,
      this._dependencyContainer,
      this._identityMap
    )
    builder.addServiceConfigs(this._operationServiceConfigs)
    return builder
  }

  private _operationServiceFactoryFactory<A extends OperationServiceAdapter<BaseModel>>(
    serviceKlass: TypeOf<A>
  ): (operationServiceBuilder: OperationServiceBuilder) => A {
    return (operationServiceBuilder: OperationServiceBuilder) => {
      return operationServiceBuilder.buildClass(serviceKlass).instance
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/providers/operation-service/operation-service.provider.ts